
















import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IDpgIncrementList } from '@/store/home/stats/types';
import * as echarts from 'echarts';
import { dpgOption, roomOption } from './options';

const Stats = namespace('home/stats');

@Component
export default class DpgIncrementChart extends Vue {
  @Stats.State('dpgIncrementList') public list!: IDpgIncrementList;

  @Prop() public cols!: number; // 布局列宽
  @Prop() public title!: string;

  @Ref('chart1') public chart1Dom!: HTMLDivElement;
  @Ref('chart2') public chart2Dom!: HTMLDivElement;

  public chart1!: echarts.ECharts;  // 专案组统计图表
  public chart2!: echarts.ECharts;  // 样板间统计图表

  public mounted() {
    this.chart1 = echarts.init(this.chart1Dom);
    this.chart2 = echarts.init(this.chart2Dom);
    this.chart1.setOption(dpgOption);  // 初始化配置(没有数据)
    this.chart2.setOption(roomOption); // 初始化配置(没有数据)
    window.addEventListener('resize', this.watchCols.bind(this));
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.watchCols);
  }

  // 列宽变更时，调整图表大小
  @Watch('cols')
  public watchCols() {
    this.$nextTick(() => {
      this.chart1.resize();
      this.chart2.resize();
    });
  }

  // 初始化图表数据
  @Watch('list.data', { immediate: true })
  public dataChange(data: IDpgIncrementList['data']) {

    // 专案组统计
    const list1 = data.filter((item) => item.type === 1);
    const xAxisTimeData = list1.map((item) => item.orgName);
    const totalList1 = list1.map((item) => ({ ...item, value: item.dpgTotalCount }));
    const hasData1 = !!list1.length;

    // 样板间统计
    const list2 = data.filter((item) => item.type === 2);
    const xAxisCountData = list2.map((item) => item.orgName);
    const totalList2 = list2.map((item) => ({ ...item, value: item.blankRoomTotalCount }));
    const hasData2 = !!list2.length;

    this.$nextTick(() => {
      this.chart1.setOption({
        tooltip: { formatter: this.tipFormat1 },
        xAxis: [{ data: xAxisTimeData }],
        series: [{ data: totalList1 }],
        graphic: { invisible: hasData1 },
        nameTextStyle: { color: hasData1 ? '' : 'transparent' },
      });
      this.chart2.setOption({
        tooltip: { formatter: this.tipFormat2 },
        xAxis: [{ data: xAxisCountData }],
        series: [{ data: totalList2 }],
        graphic: { invisible: hasData2 },
        nameTextStyle: { color: hasData2 ? '' : 'transparent' },
      });
    });
  }

  // tooltip 内容格式化(专案组)
  public tipFormat1(params: any) {
    const record = params[0]!.data;
    const totalTime = record.dpgTotalCount || 0;
    return `
      <div>组织名称：${record.orgName}</div>
      <div>新增专案组数量：${totalTime}</div>
    `;
  }

  // tooltip 内容格式化(样板间)
  public tipFormat2(params: any) {
    const record = params[0]!.data;
    const totalTime = record.blankRoomTotalCount || 0;
    return `
      <div>组织名称：${record.orgName}</div>
      <div>新增样板间数量：${totalTime}</div>
    `;
  }
}
